import { PopoutAccountOptions } from "@/base/NewselaGlobalLayoutV2/NavigationBar/UserProfileMenu/UserProfilePopout/PopoutAccountOptions";
import { PopoutSubscriptions } from "@/base/NewselaGlobalLayoutV2/NavigationBar/UserProfileMenu/UserProfilePopout/PopoutSubscriptions";
import { PopoutUserInformation } from "@/base/NewselaGlobalLayoutV2/NavigationBar/UserProfileMenu/UserProfilePopout/PopoutUserInformation";
import { popoutContainerCss } from "@/base/NewselaGlobalLayoutV2/NavigationBar/UserProfileMenu/UserProfilePopout/UserProfilePopout.styles";

const UserProfilePopout = () => {
  return (
    <div css={popoutContainerCss} data-testid="user-profile-popout">
      <PopoutUserInformation />
      <PopoutSubscriptions />
      <PopoutAccountOptions />
    </div>
  );
};

UserProfilePopout.displayName = "UserProfilePopout";
export { UserProfilePopout };
